export default __webpack_public_path__ + "static/bcorp-60943d46c32dd39ed18cb67321915183.svg";